<template>
  <button
    class="ml-2 flex items-center rounded-md bg-lk-green px-3 py-2 text-sm text-white hover:bg-lk-green-deep disabled:opacity-50"
    :disabled="repeatSubOrderMutation.isLoading.value"
    @click="handleRepeatSubOrder"
  >
    <template v-if="repeatSubOrderMutation.isLoading.value">
      <loading-spinner class="mr-2" />
      Agregando...
    </template>
    <template v-else>
      <ShoppingCartIcon class="mr-2 size-4" />
      Repetir pedido
    </template>
  </button>
</template>

<script lang="ts" setup>
import { ShoppingCartIcon } from '@heroicons/vue/24/outline';
import { useMutation } from 'vue-query';
import cartProductsApi from 'api/cart-products';
import productsApi from 'api/products';
import useGeneralMenuStore from 'stores/general-menu-store';
import useCartStore from 'stores/cart';
import LoadingSpinner from './shared/loading-spinner.vue';

interface SubOrderRepeatSubOrderButtonProps {
  subOrderId: number;
}

const props = defineProps<SubOrderRepeatSubOrderButtonProps>();

const menuStore = useGeneralMenuStore();
const cartStore = useCartStore();

const loadCartFromAPI = async (cartProducts: CartProduct[]) => {
  const promises = cartProducts.map((cartProduct) => {
    if (!cartStore.items[cartProduct.productId]) {
      return productsApi.get(cartProduct.productId).then((productResponse) => {
        const product = productResponse.data.product as Product;
        cartStore.items[cartProduct.productId] = {
          product,
          quantity: cartProduct.quantity,
          wholesalePriceCents: cartProduct.wholesalePriceCents,
        };
      });
    }

    cartStore.items[cartProduct.productId].quantity = cartProduct.quantity;
    return Promise.resolve();
  });

  await Promise.all(promises);
};

const repeatSubOrderMutation = useMutation(() => cartProductsApi.addFromSubOrder(props.subOrderId), {
  onSuccess: async (response) => {
    const cartProducts = response.data.cartProducts as CartProduct[];
    await loadCartFromAPI(cartProducts);
    menuStore.showCartSidebar = true;
  },
});

const handleRepeatSubOrder = () => {
  repeatSubOrderMutation.mutate();
};
</script>
